import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Megaphone } from "lucide-react";
import { api } from "@/lib/api";

export default function AnnuncioEditor() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/announcement").then((r) => setData(r.data)).catch(() => toast.error("Errore nel caricamento"));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/announcement", data);
      toast.success(data.active ? "Annuncio pubblicato in cima al sito" : "Annuncio disattivato");
    } catch (err) {
      toast.error(err.response?.status === 401 ? "Sessione scaduta: esci e accedi di nuovo" : "Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };

  if (!data) {
    return <p className="font-mono-alt text-xs uppercase tracking-[0.25em] text-stone-400">Caricamento…</p>;
  }

  return (
    <div data-testid="admin-announcement-editor">
      <h1 className="font-display text-3xl font-semibold text-ink sm:text-4xl">Annuncio in evidenza</h1>
      <p className="mt-2 text-sm text-stone-500">
        Il testo appare in una barra bordeaux in cima al sito. Perfetto per novità stagionali: &ldquo;Il panettone è
        arrivato!&rdquo;, &ldquo;Nuovo gusto del mese…&rdquo;, &ldquo;Serata con musica dal vivo venerdì&rdquo;.
      </p>

      <div className="mt-8 rounded-2xl border border-bordeaux/15 bg-white p-5 sm:p-7">
        <textarea
          data-testid="admin-announcement-input"
          rows={3}
          value={data.text}
          onChange={(e) => setData((d) => ({ ...d, text: e.target.value }))}
          placeholder="Scrivi qui l'annuncio (es. Da oggi disponibili le colombe artigianali: prenota la tua!)"
          className="w-full rounded-xl border border-bordeaux/20 px-4 py-3 text-sm outline-none focus:border-bordeaux"
        />
        <label className="mt-4 flex items-center gap-3">
          <input
            data-testid="admin-announcement-active-toggle"
            type="checkbox"
            checked={data.active}
            onChange={(e) => setData((d) => ({ ...d, active: e.target.checked }))}
            className="h-4 w-4 accent-[#AB182B]"
          />
          <span className="font-display text-lg font-medium text-ink">Annuncio attivo e visibile sul sito</span>
        </label>
      </div>

      <button
        data-testid="admin-announcement-save-button"
        onClick={save}
        disabled={saving}
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-bordeaux px-10 py-4 font-mono-alt text-xs uppercase tracking-[0.22em] text-ivory transition-transform duration-300 hover:scale-[1.03] disabled:opacity-60"
      >
        <Megaphone className="h-4 w-4" /> {saving ? "Salvataggio…" : "Salva annuncio"}
      </button>
    </div>
  );
}
